import { useResourceContext } from "@/layouts/ResourceContext";
import { InstanceInfo } from "../InstanceInfo";
import { useResourceParams } from "@refinedev/core";
import { useOne } from "@/hooks";

export const InstanceDetailPanel = ({ resource }) => {
  const { state } = useResourceContext();
  const { action } = useResourceParams();
  const isList = action === "list";
  const isShow = action === "show";
  const selected = (isList || isShow) && state.selectedResources[0];
  const { data, isLoading } = useOne({
    id: action === "list" ? selected?.id : null,
    skip: isList && !selected,
  });
  let loading = isList ? false : isLoading;
  let instance = selected ? (isList ? data || selected : data) : null;
  return (
    <div>
      {loading && <div>Loading...</div>}
      {instance && (
        <InstanceInfo
          data={{ status: "OK", value: instance }}
          resource={resource}
        />
      )}
    </div>
  );
};
